import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { apiAccess } from '../../docs-routes'

const ApiAccess = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      API access keys can be generated to enable direct API requests to our service endpoints for use with third party clients.
    </Color>
    <DocusaurusFooter path={apiAccess} />
  </Paragraph>

export default ApiAccess
